import { handleResponse, handleError } from '../apiUtils';
import axiosInstance from '../axiosConfig';
import { getAdminBaseUrl } from './administrationUtils';

export function getWorkflowDefinitions(accountId) {
  const baseUrl = getAdminBaseUrl(accountId);

  return axiosInstance
    .request({ method: 'get', url: `${baseUrl}/workflow_definitions` })
    .then(handleResponse)
    .catch(handleError);
}

export default getWorkflowDefinitions;
